import { render } from "./NotificationsButton.vue?vue&type=template&id=401d3735"
import script from "./NotificationsButton.vue?vue&type=script&lang=js"
export * from "./NotificationsButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__